var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88372 0L1.31465 5.65116H8.30994L8.77104 0H1.88372ZM10.0269 0L9.56575 5.65116H16.8161L16.355 0H10.0269ZM17.6108 0L18.0621 5.65116H25.0574L24.4884 0H17.6108ZM1.19692 6.90698L0.686742 11.9302H7.80959L8.21183 6.90698H1.19692ZM9.46764 6.90698L9.06541 11.9302H17.3165L16.9142 6.90698H9.46764ZM18.1701 6.90698L18.5723 11.9302H25.6853L25.1751 6.90698H18.1701ZM0.569009 13.186L0 18.8372H7.25035L7.71145 13.186H0.569009ZM8.95747 13.186L8.50616 18.8372H17.8757L17.4244 13.186H8.95747ZM18.6704 13.186L19.1315 18.8372H26.3721L25.803 13.186H18.6704ZM12.5581 19.4651V23.8605H13.814V19.4651H12.5581ZM8.7907 24.4884V27H17.5814V24.4884H8.7907Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpv);
export default __webpack_public_path__ + "static/media/spv.4110e3b57150471177c8216699970165.svg";
export { ForwardRef as ReactComponent };